import {
  Button,
  Layout,
  notification,
  Skeleton,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initBillSlice,
  setPropertiesBill,
  updateBill,
} from "../Slices/Bill.slice";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import { Dropdown } from "antd";
import routes from "../../../engine/routes";
import {
  diplomas,
  languagesList,
  levels,
  modeInterpretariat,
  roles,
} from "../../../utils/constants";
import { ActionRoleSpecific, userHasLevel } from "../../../engine/AuthRoute";
import { countryList } from "../../../utils/listsLabels";
import { UserContext } from "../../../engine/context/User.context";
import dayjs from "../../../utils/dayjs";
import { http } from "../../../engine/api/http";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import { ActionDropdown } from "../../../shared/components/ActionDropdown/ActionDropdown";
import { HiOutlineMail } from "react-icons/hi";
import { RenderCosts } from "../../../shared/components/Billing/RenderCosts";
import { RenderBillInfo } from "../../../shared/components/Billing/RenderBillInfo";
import { BillHeader } from "../../../shared/components/BillHeader/BillHeader";

const { Content, Sider, Header, Footer } = Layout;

export function BillDetail({ unitId, expanded, onClose }) {
  const { id } = useParams();
  const { bill, loading } = useSelector(state => state.bill);

  const { user } = useContext(UserContext);

  const { init, clear } = initBillSlice({});

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const [ready, setReady] = useState(false);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const {} = bill;

  const sendEmail = async () => {
    let caller = await http.post("/notifications/bill", { userId: id });
    caller.status === 200 &&
      notification.success({
        message: `Email envoyé avec succès`,
      });
  };

  return (
    <>
      <BillHeader
        title={routes.billing(id).detail.title + " " + bill.bill_number}
      />
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <RenderBillInfo
            key={bill._id + bill.updatedAt}
            title={"Informations de facturation"}
            loading={loading}
            bill={bill}
          />
          <RenderCosts
            key={bill._id + bill.updatedAt}
            prestationVue={false}
            title={"Coûts de la prestation"}
            cost={bill}
            loading={loading}
          />
        </>
      )}
    </>
  );
}
